import React from 'react'
import { ConfigProvider, Segmented } from 'antd'
import { Trans } from '@lingui/react/macro'

import type { TUseDuration } from '@/contexts/PlanContext/hooks/duration'

import { EDuration } from '@/contexts/PlanContext/type'


import { cls } from 'tagged-classnames-free';
import { useMemo } from 'react';
export interface ICommonDurationProps {
  className?: string
  maxOutlets: string
  durationInfo: TUseDuration
  styles?: React.CSSProperties
  btnClassName?: (isActive: boolean) => string
  btnStyles?: (isActive: boolean) => React.CSSProperties
  saveUpClassName?: ({ duration }: { duration: EDuration }) => string
  saveUpTextClassName?: ({ duration }: { duration: EDuration }) => string
}

export interface IDurationProps extends ICommonDurationProps {}

const Duration: React.FC<IDurationProps> = (props) => {
  const { className, durationInfo } = props

  const { curDuration, toggleDuration } = durationInfo

  const options = [
    {
      label: (
        <div className='flex h-10 min-w-[134px] items-center justify-center'>
          <span
            className={cls`text-sm text-white ${curDuration === EDuration.MONTHLY ? 'font-bold' : ''}`}
          >
            <Trans>Monthly</Trans>
          </span>
        </div>
      ),
      value: EDuration.MONTHLY,
    },
    {
      label: (
        <div className='flex h-10 min-w-[134px] items-center justify-center gap-x-1'>
          <span
            className={cls`text-sm text-white ${curDuration === EDuration.YEARLY ? 'font-bold' : ''}`}
          >
            <Trans>Yearly</Trans>
          </span>
          <div className='flex h-4 min-w-[57px] items-center justify-center rounded border border-[#005429] px-[5px] text-xs text-[#00d167]'>
            <Trans>20% OFF</Trans>
          </div>
        </div>
      ),
      value: EDuration.YEARLY,
    },
  ]

  const curValue = useMemo(() => {
    return options.find((item) => item.value === curDuration)
  }, [curDuration])

  return (
    <div>
      <ConfigProvider
        theme={{
          components: {
            Segmented: {
              trackBg: 'var(--f-other-1)',
              trackPadding: '4px',
            },
          },
        }}
      >
        <Segmented
          options={options}
          size='large'
          value={curValue?.value}
          onChange={(value) => {
            toggleDuration(value as EDuration)
          }}
        />
      </ConfigProvider>
    </div>
  )
}

export default Duration
